var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    className: "bg",
    d: "M2.66602 5.3335V12.6668H7.38602C7.35268 12.4468 7.33268 12.2268 7.33268 12.0002C7.33268 9.42016 9.41935 7.3335 11.9993 7.3335C12.466 7.3335 12.9127 7.40016 13.3327 7.52683V5.3335H2.66602Z",
    fill: "#573B76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66732 12.6668V5.3335H13.334V7.52683C13.814 7.6735 14.2673 7.88683 14.6673 8.1735V5.3335C14.6673 4.5935 14.074 4.00016 13.334 4.00016H10.6673V2.66683C10.6673 1.92683 10.074 1.3335 9.33398 1.3335H6.66732C5.92732 1.3335 5.33398 1.92683 5.33398 2.66683V4.00016H2.66732C1.92732 4.00016 1.34065 4.5935 1.34065 5.3335L1.33398 12.6668C1.33398 13.4068 1.92732 14.0002 2.66732 14.0002H7.78732C7.58732 13.5868 7.45398 13.1402 7.38732 12.6668H2.66732ZM6.66732 2.66683H9.33398V4.00016H6.66732V2.66683Z",
    fill: "#573B76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 8.6665C10.1593 8.6665 8.66602 10.1598 8.66602 11.9998C8.66602 13.8398 10.1593 15.3332 11.9993 15.3332C13.8393 15.3332 15.3327 13.8398 15.3327 11.9998C15.3327 10.1598 13.8393 8.6665 11.9993 8.6665ZM13.0993 13.5665L11.666 12.1332V9.99984H12.3327V11.8598L13.566 13.0932L13.0993 13.5665Z",
    fill: "#573B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagClock);
export default __webpack_public_path__ + "static/media/bag-clock.40a6cfb21371526c5da62064ba2a1351.svg";
export { ForwardRef as ReactComponent };